// src/api/userAPI.js
import apiClient from './client';

const USERS_URL = '/api/v1/auth/users';
const CREATE_USER_URL = '/api/v1/auth/create-user';

// Get all users (SuperAdmin only)
export const getUsers = async () => {
  try {
    const response = await apiClient.get(USERS_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Get current user info
export const getCurrentUser = async () => {
  try {
    const response = await apiClient.get('/api/v1/auth/me');
    return response.data;
  } catch (error) {
    console.error('Error fetching current user:', error);
    throw error;
  }
};

// Create a new user (SuperAdmin only)
export const createUser = async (userData) => {
  try {
    const response = await apiClient.post(CREATE_USER_URL, userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

// Update an existing user
export const updateUser = async (userId, userData) => {
  try {
    const response = await apiClient.put(`/api/v1/auth/users/${userId}`, {
      first_name: userData.first_name,
      last_name: userData.last_name,
      company_id: userData.company_id,
      phone: userData.phone,
      password: userData.password
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

// Delete a user
export const deleteUser = async (userId) => {
  try {
    const response = await apiClient.delete(`/api/v1/auth/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

// Update current user's profile
export const updateCurrentUserProfile = async (profileData) => {
  try {
    // First get current user to get the user_id
    const currentUser = await getCurrentUser();
    const response = await apiClient.put(`/api/v1/auth/users/${currentUser.user_id}`, {
      first_name: profileData.first_name,
      last_name: profileData.last_name,
      phone: profileData.phone
    });
    return response.data;
  } catch (error) {
    console.error('Error updating current user profile:', error);
    throw error;
  }
};

// Change current user's password
export const changeCurrentUserPassword = async (passwordData) => {
  try {
    // First get current user to get the user_id
    const currentUser = await getCurrentUser();
    const response = await apiClient.put(`/api/v1/auth/users/${currentUser.user_id}`, {
      password: passwordData.newPassword
    });
    return response.data;
  } catch (error) {
    console.error('Error changing current user password:', error);
    throw error;
  }
};